import { AxiosResponse } from 'axios';
import { useEffect, useState } from 'react';
import { getData } from '../api';

let data: Promise<AxiosResponse<any>> | undefined;

function getDataOnce() {
  if (data) return data;

  data = getData().catch((err) => {
    data = undefined;
    throw err;
  });

  return data;
}

export default function useOptionsData() {
  const [data, setData] = useState<Record<string, any>>();
  const [isLoading, setIsLoading] = useState(Boolean(data));

  useEffect(() => {
    getDataOnce()
      .then((response) => setData(response.data.data))
      .finally(() => setIsLoading(false));
  }, []);

  return { data, isLoading };
}
